const types = {
  // GET SUBSCRIPTION PLAN
  GET_SUBSCRIPTION: "GET_SUBSCRIPTION",
  GET_SUBSCRIPTION_RESP: "GET_SUBSCRIPTION_RESP",
  GET_SUBSCRIPTION_CLEAR: "GET_SUBSCRIPTION_CLEAR",

  // GET TESTIMONAL DATA
  GET_TESTIMONAL: "GET_TESTIMONAL",
  GET_TESTIMONAL_RESP: "GET_TESTIMONAL_RESP",
  GET_TESTIMONAL_CLEAR: "GET_TESTIMONAL_CLEAR",
};

export default types;
